/** Ghost preview opacity while dragging — AC WMPCM-11014 specifies 60%. */
export const CLIKART_DRAG_GHOST_OPACITY = 0.6

/** Thumbnail opacity while its ClikArt is being dragged. */
export const CLIKART_TRAY_DRAGGING_THUMB_OPACITY = 0.6

/** Keyboard placement: center of spread when no pointer position. */
export const CLIKART_KEYBOARD_DEFAULT_CENTER_FRACTION = 0.5
